import find from 'lodash.find';


const getPage = (pages, label) => {
  return find(pages, { label });
};

export default getPage;
